import clsx from "clsx";
import React from "react";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        "animate-pulse bg-[#F4F5F7] relative overflow-hidden shimmer",
        className
      )}
      {...props}
    />
  );
}

// Wave effect skeleton
function SkeletonWave({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={clsx("rounded-md shimmer-wave", className)} {...props} />
  );
}

export { SkeletonWave, Skeleton };
